export default __webpack_public_path__ + "images/Chong-Kaoh-celestial-nymph-on-the-ceiling.webp";